import React from 'react';

interface Props {
  label: string;
  value: string;
  hint?: string | null;
}

export default function StatRow({ label, value, hint }: Props): React.ReactElement {
  const dim = value === '—' || value === '0';
  return (
    <div className="flex items-baseline justify-between py-2 border-b border-gray-800/40 last:border-b-0">
      <div>
        <p className="text-sm text-gray-400">{label}</p>
        {hint && <p className="text-[11px] text-gray-600 mt-0.5">{hint}</p>}
      </div>
      <p className={`text-base font-semibold tabular-nums ${dim ? 'text-gray-600' : 'text-white'}`}>
        {value}
      </p>
    </div>
  );
}
